"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategory = void 0;
var ProductCategory;
(function (ProductCategory) {
    ProductCategory[ProductCategory["Software"] = 0] = "Software";
    ProductCategory[ProductCategory["Kits"] = 1] = "Kits";
    ProductCategory[ProductCategory["Services"] = 2] = "Services";
})(ProductCategory = exports.ProductCategory || (exports.ProductCategory = {}));
//# sourceMappingURL=ProductCategory.js.map